// extracted by mini-css-extract-plugin
module.exports = {"iconSize":"iconSize_RCnUn","topNav":"topNav_2HRrY","settings":"settings_3ZBOv"};